import dayjs from "dayjs";
export function jToMySqlDate(jDate){
    return jDate.slice(0,10)
}
export function formatDateToMySql(date) {
    const rawDate = date.toDateString();
    return dayjs(rawDate).format('YYYY-MM-DD');

}

export function ToMySqlDate(date){
    const a = date
    const y = a.year().toString()
    let m = (a.month()+1)
    m = m>9?m:("0"+m.toString())
    let d = a.date().toString()
    d = d>9?d:("0"+d.toString())
    return (y+"-"+m+"-"+d)
}

export function ToBritishDate(date){
    const a = dayjs(date)
    const y = a.year().toString()
    let m = (a.month()+1)
    m = m>9?m:("0"+m.toString())
    let d = a.date().toString()
    d = d>9?d:("0"+d.toString())
    return (d+"-"+m+"-"+y)
}
export function ToJsDate(mySqlDate){
    return dayjs(mySqlDate,"DD-MM-YYYY")
}

export function jDateToMySql(date){
    return `${date.getFullYear()}-${(date.getMonth()+1)<10?"0"+(date.getMonth()+1):(date.getMonth()+1)}-${date.getDate()<10?"0"+date.getDate():date.getDate()}`
}